import { render, staticRenderFns } from "./KolonneSettingsVehiclesRankingLegend.vue?vue&type=template&id=41d3cc62"
import script from "./KolonneSettingsVehiclesRankingLegend.vue?vue&type=script&lang=js"
export * from "./KolonneSettingsVehiclesRankingLegend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports